// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__D-E3j","title":"BackImages_title__1nC8Z","images":"BackImages_images__-3RpO"};